
<template>
<b-modal
    v-if="workflow"
    ref="modal"
    id="agExportModal"
    class="agModal"
      :class="{'agModal-loading':isLoading}"
    centered
    no-close-on-esc
    no-close-on-backdrop
    @keyup.enter.native="saveButton_click">
    <template slot="modal-header">
      <h4 class="agModal-title">Export Workflow</h4>
    </template>
     <b-form-textarea
      ref="text"
      id="agExportModal-text"
      v-model="exportText"
      no-resize
      :disabled="isLoading">
    </b-form-textarea>
    <b-spinner v-if="isLoading" id="agExportModal-textSpinner"></b-spinner>
    <div v-if="modalMessage">
      <hr>
      <label class="agModal-message" :class="modalMessageClass">{{modalMessage}}</label>
    </div>
    <template slot="modal-footer" slot-scope="{cancel}">
      <b-button class="agModal-buttonLeft" @click="cancel">Cancel</b-button>
      <b-button id="agExportModal-copyButton" class="agImageButton" :disabled="isLoading" @click="copyButton_click"><fa icon="clipboard"/></b-button>
      <b-button class="agModal-buttonRight" variant="primary" :disabled="isLoading" @click="saveButton_click">Save To File</b-button>
    </template>
  </b-modal>
</template>






<script>

// components


// modules
import Server from "src/server";
import {save} from "save-file";

export default {
    name: "ag-export-modal",

    components: {

    },

    props:{
        workflow: Object
    },

    data(){
        return {
            isLoading: false,
            modalMessage: "",
            modalMessageClass: "",
            errorField: "",
            exportText: "",
            exportCancel: null,
        };
    },

    computed: {
    },
    
    watch: {
      
    },

    created() {

    },

    mounted() {
      
    },

    methods: {

        // UI Events

        
        async saveButton_click() {
          if(!this.validate()) {
            return;
          }

          var filename = this.workflow.name + ".txt";
          await save(this.exportText, filename);
        },

        copyButton_click() {
            this.$refs.text.select();
            navigator.clipboard.writeText(this.exportText).then(function(){
            }).catch( function() {
              console.error("error with copy")
            });
            this.modalMessage = "Copied to clipboard";
            this.modalMessageClass = "agModal-successMessage";
        },

        // emitted Events


        // other

        show() {
          setTimeout(() => {
            this.reset();
            this.$refs.modal.show();
          }, 250);
        },

        hide() {
          this.$refs.modal.hide();
        },

        reset() {
          this.modalMessage = "";
          this.modalMessageClass = "";
          this.errorField = "";
          this.setExportText();
        },

        hasError(field) {
            if (field == this.errorField) {
                return false; // false = error
            }
            return null;
        },

        validate()
        {
            this.modalMessage = "";
            this.modalMessageClass = "";
            this.errorField = "";

            return true;
        },

        async setExportText() {
            this.exportText = "";

            if(this.exportCancel) {
                this.exportCancel("cancel previous exportWorkflow call");
                this.exportCancel = null;
            }

            try {
                this.isLoading = true;
                var req = Server.get("exportWorkflow/" + this.workflow._id);
                this.exportCancel = req.cancel;
                var result = await req.promise;
                this.isLoading = false;
                if(!result.data.success)
                    throw(result.data.error);

                this.exportText = JSON.stringify(result.data.workflow);
            }
            catch (e) {
                console.log("Failed 'exportWorkflow' server call. " + e.toString());
                if(e.toString() != "cancel previous exportWorkflow call") {
                    this.modalMessage = "Failed to gather exported workflow data. Error: " + e;
                    this.modalMessageClass = "agModal-errorMessage";
                    this.isLoading = false;
                }
            }
        },
    }
}

</script>






<style scoped lang="css">

#agExportModal-text {
    height: 400px;
}

#agExportModal-textSpinner {
    position: absolute;
    width: 40px;
    height: 40px;
    top: 50%;
    left: 50%;
    margin-top: -20px;
    margin-left: -20px;
}

#agExportModal-copyButton {
    font-size: 30px;
    margin-right: 10px;
    color: gray !important;
}

</style>



// WEBPACK FOOTER //
// src/components/workflow/ExportModal.vue